import { useState } from 'react';
import { Search } from 'lucide-react';
import './SearchBar.module.css';
import styles from './SearchBar.module.css';

function SearchBar({
  label,
  value,
  onChange,
  error,
  helperText = '',
  type = "text",
  disabled = false,
  multiline = false,
  rows = 1,
  showSearchIcon = false,
  border = false,
  ...props
}) {
  const [focused, setFocused] = useState(false);

  const hasValue = value && value.length > 0;
  const isFloating = focused || hasValue;

  const InputElement = multiline ? 'textarea' : 'input';

  return (
    <div className={[
      styles.container,
      border && styles.border,
    ].filter(Boolean).join(" ")}
      style={{ ...props }}>
      <div className={styles.inputWrapper}>
        {showSearchIcon && (
          <Search className={styles.icon} />
        )}
        <label 
        htmlFor={label}
        className={[
          styles.label,
          error && styles.error,
          isFloating && styles.floating,
          focused && styles.labelFocus
        ].filter(Boolean).join(" ")}
        >
          {label}
        </label>
        <InputElement
          className={[
            styles.input,
            error && styles.error,
            (focused || value) && styles.inputFocus,
            disabled && styles.inputDisabled
          ].filter(Boolean).join(" ")}
          type={multiline ? undefined : type}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          disabled={disabled}
          rows={multiline ? rows : undefined}
        />
        <div className={styles.underline} />
      </div>
      {helperText && (
        <div className={[
          styles.helperText,
          error && styles.error
        ].filter(Boolean).join(" ")}>
          {helperText}
        </div>
      )}
    </div>
  );
}

export default SearchBar;